<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="800px"
      @close="close"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <el-form-item v-if="form.gameId" label="游戏ID" prop="gameId">
          {{ form.gameId }}
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="游戏时间" prop="gameTime">
          <el-time-picker
            is-range
            v-model="form.gameTime"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="选择时间范围"
            value-format="HH:mm:ss"
          ></el-time-picker>
        </el-form-item>
        <el-form-item label="备注" prop="text">
          <el-input
            v-model="form.text"
            type="textarea"
            class="fix-width"
            placeholder="请输入备注"
          />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { create, update } from '@/api/game'
export default {
  name: 'GameEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      form: {
        gameId: '',
        title: '',
        gameTime:"",
        text: '',
        order: 1,
      },
      rules: {
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
        gameTime:[{ required: true, trigger: 'blur', message: '请选择游戏时间' }]
      },
      dialogFormVisible: false,
    }
  },
  methods: {
    async showEdit(row) {
      if (row) {
        this.title = '修改游戏'
        this.form = Object.assign(this.form, row.basic)
        this.form.gameId = row.gameId
        this.form.title = row.title
        this.form.gameTime = [row.basic.startTime,row.basic.endTime]
      } else {
        this.title = '新增游戏'
      }
      this.dialogFormVisible = true
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const gameId = this.form.gameId
          const data = Object.assign({}, this.form)
          const startTime = data.gameTime[0]
          const endTime = data.gameTime[1]
          data.startTime = startTime
          data.endTime = endTime
          delete data.gameTime
          this.$baseConfirm(
            `你确定要${gameId ? '修改' : '新增'}游戏吗`,
            null,
            async () => {
              gameId ? await update(data) : await create(data)
              this.$baseMessage(
                `${gameId ? '修改' : '新增'}游戏成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
</style>
